<script>
    export let src;
    export let alt;
    export let videocount;
    export let watched = watched;
    export let isPlaylist;
</script>
<div class="vec-relative vec-aspect-[16/9]} vec-rounded-xl vec-rounded-bl-none {(isPlaylist)?"":"vec-overflow-hidden"}">
    {#if videocount}
    <div class="vec-absolute vec-w-[calc(100%-6px)] vec-h-[calc(100%-6px)] vec-top-[-6px] vec-right-[-6px] vec-rounded-tr-xl vec-border-t vec-border-r vec-border-midGrey"/>
    <div class="vec-absolute vec-w-[calc(100%-6px)] vec-h-[calc(100%-6px)] vec-top-[-3px] vec-right-[-3px] vec-rounded-tr-xl vec-border-t vec-border-r vec-border-midGrey"/>
    {/if}
    <img src="{src}" alt="{alt}" class="{(watched)?"vec-opacity-30":""} vec-relative vec-object-cover vec-rounded-xl vec-rounded-bl-none vec-border vec-border-midGrey vec-h-full vec-w-full"/>
    {#if videocount > 1} 
        <div class="vec-absolute vec-text-white vec-text-xs vec-uppercase vec-bottom-3 vec-right-3 vec-p-1 vec-px-2 vec-bg-black vec-rounded">{videocount} Videos</div>
    {/if}
    {#if !videocount}
    <div class="vec-absolute vec-w-full vec-h-full vec-top-0 vec-left-0 vec-flex">
        <div class="vec-relative vec-m-auto">
            <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="76" height="60" viewBox="0 0 76 60">
                <defs>
                    <filter id="ds" x="0" y="0" width="76" height="60" filterUnits="userSpaceOnUse">
                        <feOffset dy="2" input="SourceAlpha"/>
                        <feGaussianBlur stdDeviation="2" result="b"/>
                        <feFlood flood-opacity="0.50"/>
                        <feComposite operator="in" in2="b"/>
                        <feComposite in="SourceGraphic"/>
                    </filter>
                </defs>
                <g transform="matrix(1, 0, 0, 1, 0, 0)" filter="url(#ds)">
                    <path d="M56.5,48.5H8.5a8.009,8.009,0,0,1-8-8V8.5a8.007,8.007,0,0,1,8-8h48a8.007,8.007,0,0,1,8,8v32a8.009,8.009,0,0,1-8,8m-32.4-36h0v24l20.8-12Z" transform="translate(5.5 3.5)" fill="#fff" opacity="0.75"/>
                </g>
                <rect width="64" height="48" rx="8" transform="translate(5.5 3.5)" fill="none" stroke="rgba(0,0,0,0.1)" stroke-width="1"/>
            </svg>
            {#if watched}<div class="vec-absolute vec-w-[calc(100%+40px)] vec-top-[calc(100%-5px)] vec-left-[-20px] vec-text-center vec-uppercase vec-text-sm">Played</div>{/if}
        </div>
    </div>
    {/if}
</div>
